define([
	"dojo/_base/declare",
	"csi/action/NewController",
	"csi/html"
], function(declare,NewController,html) {

	return declare(NewController, {
		// Boolean: indicate that user should land on new node after node is created
		bNavigate: true,

		constructor: function(/*Object*/params) {
			// summary: set m_urlParent to that of existing node, while m_urlNode is reset to null in NewController
			this.m_urlParent = html.getElementContext(this.m_element);
		},

		_canRepeat: function() {
			// summary: disallow Save & New in this case
			return false;
		}
	});
});